import React from 'react';
export function Advertorial() {
  return <div className="w-full min-h-screen bg-[#e8f1f5] font-sans text-[#333]" data-id="element-1">
      {/* Advertisement label bar */}
      <div className="w-full bg-white pt-0 pb-7 text-center" data-id="element-2">
        <span className="text-xs text-gray-500" data-id="element-3">Advertisement</span>
      </div>

      {/* Article card */}
      <div className="px-3 pt-7 pb-[4.25rem] sm:px-4" data-id="element-4">
        <article className="mx-auto w-full max-w-[95%] bg-white px-5 pt-7 pb-10 sm:max-w-[77%] sm:px-12 sm:pt-10 sm:pb-14" data-id="element-5">
          <h1 className="text-center text-2xl font-bold leading-tight text-[#222] [word-spacing:-0.05em] sm:text-left sm:text-3xl md:-ml-4 md:text-[2.55rem] lg:whitespace-nowrap" data-id="element-6">
            1 In 3 People With Yellow Eye Gunk Risk Total Vision Loss
          </h1>

          <div className="mt-7 flex justify-center sm:mt-12" data-id="element-7">
            <img src="https://cdn.magicpatterns.com/uploads/e4TCTewqwkS7GAYRGcmqke/pasted-image.png" alt="Medical specialist examining a patient's eye with a penlight" draggable={false} className="pointer-events-none w-full max-w-[500px] select-none object-cover" data-id="element-8" />
          </div>

          <div className="mt-8 space-y-5 px-0 text-left text-base leading-[1.15] text-[#333] sm:space-y-6 sm:px-2 sm:text-lg sm:leading-tight" data-id="element-9">
            <p data-id="element-10">
              Pentagon researchers reveal an{' '}
              <strong className="font-bold" data-id="element-11">
                astonishing vision loss discovery
              </strong>
              :
            </p>

            <p data-id="element-12">
              That <strong className="font-bold" data-id="element-13">yellow gunk</strong> forming in
              your eyes every morning is a warning sign your eyes are being
              poisoned by a{' '}
              <a href="https://trackrq.dailyhomewellness.com/click" className="font-bold text-[#0d6efd] hover:underline" data-id="element-14">
                toxic gut bacteria called LPS
              </a>
              .
            </p>

            <p data-id="element-15">
              Left untreated, this could lead to sudden,{' '}
              <strong className="font-bold" data-id="element-16">irreversible vision loss</strong>.
            </p>

            <p data-id="element-17">
              Air Force eye specialists urge everyone over 45 to take action
              immediately and{' '}
              <a href="https://trackrq.dailyhomewellness.com/click" className="font-bold text-[#0d6efd] hover:underline" data-id="element-18">
                do this simple 12-second ritual to flush the toxin and protect
                their vision.
              </a>
            </p>

            <p data-id="element-19">Visit the link below to find out all about it:</p>

            <p data-id="element-20">
              <a href="https://trackrq.dailyhomewellness.com/click" className="font-bold text-[#0d6efd] hover:underline" data-id="element-21">
                &gt;&gt;&gt; Is Yellow Eye Gunk Poisoning Your Vision? (Do THIS
                to Flush It Out)
              </a>
            </p>
          </div>

          <div className="mt-7 flex justify-center" data-id="element-22">
            <a href="https://trackrq.dailyhomewellness.com/click" className="rounded-md bg-[#0d6efd] px-6 py-2.5 text-lg font-semibold text-white transition-colors hover:bg-[#0b5ed7]" data-id="element-23">
              Watch Now &gt;&gt;
            </a>
          </div>
        </article>
      </div>

      {/* Footer / disclaimer */}
      <footer className="w-full bg-[#c9dbe8] px-4 py-14 text-center text-gray-500" data-id="element-24">
        <div className="mx-auto w-full max-w-[95%] space-y-5 px-2 sm:max-w-[77%]" data-id="element-25">
          <p className="text-[12.5px] tracking-wide" data-id="element-26">
            THIS IS AN ADVERTORIAL AND NOT AN ACTUAL NEWS ARTICLE, BLOG, OR
            CONSUMER PROTECTION UPDATE.
          </p>

          <div className="text-[12.5px] leading-relaxed" data-id="element-27">
            <p data-id="element-28">DISCLAIMER</p>
            <p data-id="element-29">
              This website is not intended to provide medical advice or to take
              the place of medical advice and treatment from your personal
              physician. Visitors are advised to consult their own doctors or
              other qualified health professional regarding the treatment of
              medical conditions. The author shall not be held liable or
              responsible for any misunderstanding or misuse of the information
              contained on this site or for any loss, damage, or injury caused,
              or alleged to be caused, directly or indirectly by any treatment,
              action, or application of any food or food source discussed in
              this website. The U.S. Food and Drug Administration have not
              evaluated the statements on this website. The information is not
              intended to diagnose, treat, cure, or prevent any disease.
            </p>
            <p className="mt-4" data-id="element-30">
              Trademarks utilized on our website belong to their respective
              owners and no implied or expressed endorsement of our website or
              services is intended. Through in-depth research and experienced
              editors we provide feedback about products and services. We are
              independently owned, and opinions expressed here are our own. This
              website is an independent professional comparison and review site
              supported by referral fees from the sites and products featured.
            </p>
          </div>

          <p className="text-[12.5px]" data-id="element-31">
            ©2026 Website Name. All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>;
}